import { ApiBase } from "api/utils/api";

export class SwaggerApi {
	static getExternalApiSwaggerUrl() {
		return ApiBase.get("/swagger/external-api-swagger-url");
	}
}
